class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.init()

    // Add resize observer to update container height
    const resizeObserver = new ResizeObserver(entries => {
      let elem = document.querySelector('.product-gallery__image--active');
      elem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      this.update();
    });
    resizeObserver.observe(this);

    // Bind event listeners
    this.navItems.forEach(item => item.addEventListener('click', this.onNavItemClick.bind(this)))
    //this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    //this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    // For loop for applying button event handlers in case of using mobile slider buttons
    this.prevButton.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    this.nextButton.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    // Listen for variant selection change to make current variant image active
    window.addEventListener('message', this.onMessage.bind(this))

    //Resize image
    window.addEventListener("resize", this.onResize.bind(this));
    
    
  }

  init() {
    // Set up our DOM element variables
    this.imagesContainer = this.querySelector('.product-gallery__images');
    this.navItems = this.querySelectorAll('.product-gallery__nav-item');
    this.dots = this.querySelectorAll('.product-gallery__nav-item.dot-nav');
    this.images = this.querySelectorAll('.product-gallery__image');
    this.filteredImages = this.querySelectorAll('.product-gallery__image.filtered');
    this.filteredDots = this.querySelectorAll('.product-gallery__nav-item.dot-nav.filtered');
    this.prevButton = this.querySelectorAll('button[name="previous"]');
    this.nextButton = this.querySelectorAll('button[name="next"]');
    this.arrowContainer = this.querySelector(".carousel-arrow-container");
    this.onlyDefaultVariant = this.dataset.onlyDefaultVariant;
    // If there is no active images, or the product only has the default variant set the first image to active
    if (this.findCurrentIndex() === -1 || this.onlyDefaultVariant === 'true') {
      this.setCurrentImage(this.images[0]);
      this.setCurrentDot(this.dots[0]);
    } else {
      this.setSlideCount(this.findCurrentIndex() + 1);
      this.setCurrentDot(this.dots[this.findCurrentIndex()]);
    }

    if (window.innerWidth < 750) {
      this.imagesContainer.style.maxHeight = "none";
    } else {
      this.imagesContainer.style.maxHeight = this.querySelector(".product-gallery__image--active img").height + "px";
      
    }
    this.arrowContainer.style.top = (this.querySelector(".product-gallery__image--active img").height / 2) + "px";
  }
  

  onMessage(event) {
    if (!event.data) return;
    if (event.data.type !== 'variant_changed' || event.data.action != 'filter') {
      if (event.data.type == 'variant_changed') {
        let currentImage = Array.from(this.images).find(item => item.dataset.mediaId == event.data.variant.featured_media.id)
        if (currentImage) {
          this.setCurrentImage(currentImage)
        }
        this.setCurrentDot(this.dots[Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'))]);
      }
      if (event.data.type == 'product_gallery' && event.data.action == 'filter') {
        this.filteredImages = this.querySelectorAll('.product-gallery__image.filtered');
        this.filteredDots = this.querySelectorAll('.product-gallery__nav-item.dot-nav.filtered');
        this.setCurrentImage(this.filteredImages[0]);
        this.setCurrentDot(this.filteredDots[0]);
      }

      if (event.data.type == 'product_gallery' && event.data.action == 'unfilter') {
        this.setSlideCount(Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active')) + 1);
        this.setCurrentDot(this.dots[Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'))]);
      }
    }
  }

  onResize(event) {
    if (window.innerWidth < 750) {
      this.imagesContainer.style.maxHeight = "none";
    } else {
      this.imagesContainer.style.maxHeight = this.querySelector(".product-gallery__image--active img").height + "px";
    }
    this.arrowContainer.style.top = (this.querySelector(".product-gallery__image--active img").height / 2) + "px";
    
  }

  onVariantChange(event) {
    if (!event.data || event.data.type !== 'variant_changed') return 
    const currentImage = Array.from(this.images).find(item => item.dataset.mediaId == event.data.variant.featured_media.id)
    if (currentImage) {
      this.setCurrentImage(currentImage)
    }
    this.setSlideCount(Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active')) + 1);
  }

  onNavItemClick(event) {
    window.postMessage({ type: 'product_gallery', action: "nav_click" }, '*');
    const mediaId = event.target.closest('li').dataset.mediaId;
    const targetDot = event.target.closest('li.dot-nav');
    this.setCurrentDot(targetDot);
    this.images.forEach(item => item.classList.remove('product-gallery__image--active'));
    this.setCurrentImage(Array.from(this.images).find(item => item.dataset.mediaId === mediaId))
    if (this.querySelectorAll('.product-gallery__image.filtered').length > 0) {
      this.setSlideCount(Array.from(this.filteredImages).findIndex(item => item.classList.contains('product-gallery__image--active')) + 1);
    } else {
      this.setSlideCount(Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active')) + 1);
    }
  }

  update() {
    window.postMessage({ type: 'product_gallery', action: "update" }, '*');
    // For loop for applying button event handlers in case of using mobile slider buttons
    this.prevButton.forEach((button) => {
      button.removeAttribute('disabled');
    });
    this.nextButton.forEach((button) => {
      button.removeAttribute('disabled');
    });
  }

  setCurrentImage(elem) {
    window.postMessage({ type: 'product_gallery', action: "set_image", media_id: elem.dataset.mediaId }, '*');
    this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
    elem.classList.add('product-gallery__image--active')
    elem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    this.update()
  }

  setCurrentDot(elem) {
    window.postMessage({ type: 'product_gallery', action: "set_dot" }, '*');
    if (this.dots.length > 0) {
    this.dots.forEach(item => item.classList.remove('product-gallery__nav-item--active'))
    elem.classList.add('product-gallery__nav-item--active');
    this.update()
    }
  }

  setSlideCount(index) {
    window.postMessage({ type: 'product_gallery', action: "set_count" }, '*');
    let sliderCount = document.getElementById("sliderCount");
    if (sliderCount) {
      document.getElementById("sliderCountCurrent").textContent = index;
    }
  }

  findCurrentIndex() {
    if ($(".product-gallery__images .filtered").length > 0) {
      return Array.from(this.filteredImages).findIndex(item => item.classList.contains('product-gallery__image--active'));
    } else {
      return Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'));
    }
    
  }

  onButtonClick(event) {
    event.preventDefault();
    let index = this.findCurrentIndex();
    let slideCount = this.images.length - 1;
    if ($(".product-gallery__images .filtered").length > 0) {
      slideCount = $(".product-gallery__images #sliderCount").attr("data-slides") - 1;
      slideCount = $(".product-gallery__images .filtered").length - 1;
    }
    if (event.currentTarget.name === 'next') {
      if (index == slideCount) {
        index = 0;
      } else {
        index++;
      }
      
    } else {
      if (index == 0) {
        index = slideCount;
      } else {
      index--;
      }
    }

    this.setSlideCount(index + 1);
    
    if ($(".product-gallery__images .filtered").length > 0) {
      this.setCurrentImage(this.filteredImages[index]);
      this.setCurrentDot(this.filteredDots[index]);
    } else {
      this.setCurrentImage(this.images[index]);
      this.setCurrentDot(this.dots[index])
    }
    
  }
}

customElements.define('product-gallery', ProductGallery);

